/*
 * @Author: xionggang 
 * @Date: 2021-08-Mo 10:55:44 
 * @Last Modified by:   xionggang 
 * @Last Modified time: 2021-08-Mo 10:55:44 
 */
// 匹配指定的vue格式文件放在集合统一导出
const path = require("path");
const files = require.context("./", false, /\.vue$/);
const modules = {}

files.keys().forEach(key => {
    const name = path.basename(key, '.vue')
    modules[name] = files(key).default || files(key)
})

export default modules